@if (content) {
    @if (!hideAttachments) {
        <div class="d-flex flex-col gap-15">
            @if ('show_attachment_above_text' in this.content && images.length > 0 && content.show_attachment_above_text) {
                <div class="px-16 pt-10">
                    @if (images.length > 1) {
                        <app-embla-carousel [images]="images"></app-embla-carousel>
                    } @else {
                        <img #image [src]="images[0]" class="w-100 smallerImg" mat-card-image>
                    }
                </div>
            }
        </div>
    }
    <mat-card-content class="postContent">
        <div #textContent [class.partial]='!show'>
            <div [innerHTML]="formattedText | mentionFormat" class="innerContent ck-editorControl ck-content"></div>
            <button #selectedMenuTrigger [matMenuTriggerFor]="menu" style="height: 0;opacity: 0;width: 0"></button>
            <mat-menu #menu="matMenu" class="userDisplayMenu">
                @if (selectedMenuUser) {
                    <app-user-info [user]="selectedMenuUser"></app-user-info>
                }
            </mat-menu>
        </div>
        @if (displayExpandContent) {
            <div class="w-100 text-center my-10">
                <button (click)="show = !show" color="accent" mat-raised-button>Show
                    @if (!show) {
                        More
                    }
                    @if (show) {
                        Less
                    }
                </button>
            </div>
        }
    </mat-card-content>
    @if (!hideAttachments) {
        <div class="d-flex flex-col gap-15">
            @if (heatmap) {
                <div class="mt-10 my-10">
                    <app-heatmap-vote [heatmap]="heatmap"/>
                </div>
            }
            @if (images.length > 0 && !content.show_attachment_above_text) {
                <div class="px-16 pt-10">
                    @if (images.length > 1) {
                        <app-embla-carousel [images]="images"></app-embla-carousel>
                    } @else {
                        <img #image [src]="images[0]" class="w-100 smallerImg" mat-card-image>
                    }
                </div>
            }
            @for (attachment of this.content?.attachments; track attachment) {
                @if (attachment.attachment_type == 'document') {
                    <div class="w-100 text-center">
                        <a [href]="attachment.file" color="accent" mat-raised-button target="_blank">{{ attachmentButtonText }}</a>
                    </div>
                }
                @if (attachment?.videoUrl) {
                    <video (play)="reportAction()" class="youtubeEmbed mt-10 px-16 videoFile" controls>
                        @if (this.get_url_extension(attachment.file) == 'WebM' || this.get_url_extension(attachment.file) == 'ogg') {
                            <source [src]="attachment.videoUrl"
                                    [type]="'video/'  + this.get_url_extension(attachment.file)">
                        } @else {
                            <source [src]="attachment.videoUrl" [type]="'video/mp4'">
                        }
                        Your browser does not support the video tag.
                    </video>
                }
                @if ((attachment.safeVideoLink && !attachment.isApiUrl) || attachment.safeImageLink) {
                    <iframe (iframeClick)="reportAction(attachment.url)"
                            [src]="attachment.safeVideoLink || attachment.safeImageLink"
                            allow="encrypted-media; web-share; autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                            appIframeTracker
                            appResizableIframe
                            class="youtubeEmbed mt-10 px-16"
                            frameborder="0"
                            height="auto" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                }
                @if (attachment.safeVideoLink && attachment.isApiUrl) {
                    <video (play)="reportAction(attachment.url)"
                           [src]="attachment.safeVideoLink"
                           class="youtubeEmbed mt-10 px-16"
                           controls></video>
                }
                @if (attachment.attachment_type === 'audio') {
                    <div class="px-16 pt-10">
                        <app-audio-player [file]="attachment.file"></app-audio-player>
                    </div>
                }
                @if (attachment?.attachment_type == 'survey_url' && this.currentUser?.id && this.content?.id) {
                    <div class="flex-col justify-content-center mt-10 align-items-center">
                        @if ((this.isMobile || this.content.iframe_survey) && this.surveyCompleted) {
                            <!--  mobile cant see tooltips -->
                            <p>Survey already completed</p>
                        } @else if ('iframe_survey' in this.content && this.content.iframe_survey && (this.hasCommunityRole(['member']) || this.isSuperUser())) {
                            <iframe [src]="attachment.safeLink"
                                    allow="encrypted-media;"
                                    appResizableIframe
                                    sandbox="allow-forms allow-scripts allow-same-origin"
                                    class="surveyEmbed mt-10 px-16"
                                    frameborder="0"
                                    height="100%" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                        } @else {
                            <!--   If not mobile and not iframed -->
                            <div [matTooltip]="this.surveyCompleted? (this.hasCommunityRole(['member']) || this.isSuperUser()?'Survey already completed': 'Current user role cannot complete surveys') : 'Click to complete a survey'">
                                <button (click)="openSurvey(attachment?.url + '?id=' + this.currentUser?.id + '&survey=' + this.content?.id)"
                                        [disabled]="this.surveyCompleted" color="primary"
                                        data-id="{{this.currentUser?.id}} {{this.content?.id}} "
                                        mat-raised-button>
                                    Start Survey
                                </button>
                            </div>
                        }
                    </div>
                }
                @if (attachment?.attachment_type == 'url') {
                    <div class="flex-row justify-content-center mt-10">
                        <a [href]="attachment?.url" color="primary" mat-raised-button target="_blank">
                            {{ linkButtonText }}
                        </a>
                    </div>
                }
            }
        </div>
    }
}
